const RepresentativeTableConfig = [
	{
		title: '',
		dataSource: 'avatar',
		width: 300
	},
	{
		title: 'Code',
		dataSource: 'Code',
		sortable: true,
		width: 600
	},
	{
        title: 'Name',
		dataSource: 'Name',
		sortable: true,
		width: 600
	},
	{
		title: 'Details',
		dataSource: 'Details',
		width: 300
	},
	{
		title: 'Status',
		dataSource: 'Status',
		width: 300
	},
]
export default RepresentativeTableConfig
